<template>
  <li class="breadcrumbs-item d-flex align-items-center flex-shrink-0">
    <svg
      aria-hidden="true"
      tabindex="-1"
      class="d-block me-2"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.85089 5.26397L1.29188 9.86024C1.14592 10.0062 0.909893 10.0062 0.76393 9.86024L0.149023 9.24534C0.00306008 9.09937 0.00306008 8.86335 0.149023 8.71739L3.82915 4.99999L0.149023 1.2826C0.00306008 1.13664 0.00306008 0.900615 0.149023 0.754653L0.76393 0.139745C0.909893 -0.00621724 1.14592 -0.00621724 1.29188 0.139745L5.85089 4.73602C5.99685 4.88198 5.99685 5.11801 5.85089 5.26397Z"
        fill="black"
      />
    </svg>

    <slot />
  </li>
</template>
